import { useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAddVideoMutation } from "../../../../features/video/videoApi";

export default function AddVideo () {
    const [title, setTitle] = useState("");
	const [description, setDescription] = useState("");
	const [url, setUrl] = useState("");

    const navigate = useNavigate();

    const [ addVideo, { isLoading, isError, isSuccess } ] = useAddVideoMutation() || [];
    useEffect(() => {
        if (isSuccess) {
            navigate("/admin/videos");
        }
    }, [isSuccess, navigate]);

	const handleFormSubmit = (e) => {
        e.preventDefault();

        let videoData = {
            title,
            description,
            url
        };

        addVideo(videoData);    
    };

    return (
        <section className="py-6 bg-primary place-items-center">
            <div className="mx-auto max-w-5xl px-5 lg:px-0">
                <div>
                    <h2 className="mt-6 text-center text-3xl font-extrabold text-slate-100">
                        Add Video
                    </h2>
                </div>
                <form
                    onSubmit={handleFormSubmit}
                    className="mt-8 space-y-6"
                >
                    <div className="rounded-md shadow-sm ">
                        <div>
                            <label className="text-sm font-bold">
                                Title:
                            </label>
                            <input
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                                id="name"
                                name="name"
                                type="name"
                                autoComplete="name"
                                required
                                className="login-input rounded-t-md"
                                placeholder="Video title"
                            />
                        </div>
                        <div className="mt-4">
                            <label className="text-sm font-bold">
                                Description:
                            </label>
                            <textarea
                                value={description}
                                onChange={(e) =>
                                    setDescription(e.target.value)
                                }
                                id="email-address"
                                name="description"
                                type="text"
                                required
                                className="login-input "
                                placeholder="Video description"
                            />
                        </div>
                        <div className="mt-4">
                            <label className="text-sm font-bold">Video Url:</label>
                            <input
                                value={url}
                                onChange={(e) => setUrl(e.target.value)}
                                id="email-address"
                                name="url"
                                type="url"
                                autoComplete="url"
                                required
                                className="login-input "
                                placeholder="Video url"
                            />
                        </div>
                    </div>

                    <div className="flex justify-center">
                        <button
                            type="submit"
                            className="group relative flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
                        >
                            Add
                        </button>
                    </div>
                </form>
            </div>
        </section>
    );
}